module.exports = __webpack_public_path__ + "static/media/search-zoom-in.8cb0a72f.svg";